/* eslint-env browser */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';

import { setHeader, loadScheduleList } from 'actions';

import Loading from 'components/common/Loading';
import ScheduleList from 'components/calendar/ScheduleList';
import ScheduleListItem from 'components/calendar/ScheduleListItem';

class ScheduleListPage extends Component {
  constructor(props) {
    super(props);

    this.renderScheduleListItem = this.renderScheduleListItem.bind(this);
  }

  componentWillMount() {
    this.props.setHeader('Schedules');
    this.props.loadScheduleList();
  }

  renderScheduleListItem(schedule, drawDivider = false) {
    return (
      <ScheduleListItem
        drawDivider={drawDivider}
        showChevron
        schedule={schedule}
        key={`${schedule.id}`}
        onSelect={selectedSchedule => this.props.push(`/schedule/view/${selectedSchedule.id}`)}
      />
   );
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (this.props.schedules.length === 0) {
      return (
        <section className="schedule-page">
          <div className="schedule-no-schedules">
            <p>There are no schedules for you to view right now.</p>
          </div>
        </section>
      );
    }

    return (
      <section className="schedule-page">
        <ScheduleList
          schedules={this.props.schedules}
          isLoading={this.props.isLoading}
          renderItem={this.renderScheduleListItem}
        />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { schedule } = state;
  const { schedules, isLoading } = schedule;

  return {
    isLoading,
    schedules,
  };
}

export default connect(mapStateToProps, {
  setHeader,
  loadScheduleList,
  push,
})(ScheduleListPage);



// WEBPACK FOOTER //
// ./src/app/containers/ScheduleListPage.js